import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const PALETTE = ['#0e48ad', '#17a2b8', '#28a745', '#fd7e14', '#e0a800', '#6f42c1', '#dc3545', '#20c997', '#607d8b', '#e83e8c', '#ffc107', '#795548'];

const LOWER_WORDS = new Set([
  'de', 'da', 'do', 'das', 'dos', 'e', 'a', 'o', 'as', 'os', 'em', 'na', 'no',
  'nas', 'nos', 'para', 'por', 'com', 'sem', 'sob', 'sobre', 'entre', 'até',
  'ao', 'aos', 'à', 'às', 'um', 'uma', 'uns', 'umas', 'se', 'que', 'ou',
]);

const toTitleCase = str =>
  str
    .toLowerCase()
    .split(/(\s+)/)
    .map((word, index, arr) => {
      if (word.trim() === '') return word;
      const isFirstWord = arr.slice(0, index).every(w => w.trim() === '');
      if (!isFirstWord && LOWER_WORDS.has(word.toLowerCase())) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');

const TipoDemandaChart = ({ data }) => {
  const entries = Object.entries(data).sort((a, b) => b[1] - a[1]);
  const labels = entries.map(e => toTitleCase(e[0]));
  const values = entries.map(e => e[1]);

  const isEmpty = labels.length === 0;
  const finalLabels = isEmpty ? ['Sem dados'] : labels;
  const finalValues = isEmpty ? [1] : values;

  const barLabelsPlugin = {
    id: 'barLabels',
    afterDatasetsDraw(chart) {
      const { ctx } = chart;
      const meta = chart.getDatasetMeta(0);
      const ds = chart.data.datasets[0];
      if (!meta.data.length) return;
      ctx.save();
      ctx.font = '600 11px "Segoe UI", sans-serif';
      ctx.fillStyle = '#495057';
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      meta.data.forEach((bar, i) => {
        const value = ds.data[i];
        if (value === 0) return;
        ctx.fillText(String(value), bar.x + 8, bar.y);
      });
      ctx.restore();
    },
  };

  const chartData = {
    labels: finalLabels,
    datasets: [
      {
        data: finalValues,
        backgroundColor: finalLabels.map((_, i) => PALETTE[i % PALETTE.length]),
        borderRadius: 4,
        borderSkipped: false,
        barPercentage: 1,
        categoryPercentage: 0.9,
        maxBarThickness: 26,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#fff',
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: false },
      },
      y: {
        grid: { display: false },
        border: { display: false },
        ticks: {
          font: { size: 11 },
          color: '#495057',
          crossAlign: 'far',
          autoSkip: false,
        },
      },
    },
    layout: { padding: { top: 4, right: 30 } },
    animation: { duration: 800 },
  };

  return (
    <div className="d-flex flex-column h-100">
      <h5 className="text-center text-dark mb-2">DFD POR TIPO DE DEMANDA</h5>
      <div className="flex-grow-1">
        <Bar data={chartData} options={options} plugins={[barLabelsPlugin]} />
      </div>
    </div>
  );
};

export default TipoDemandaChart;
